import { Route, Routes } from 'react-router-dom';
import loginImg from '../assets/images/auth_root_bg_img.png';
import AgrementPage from '../pages/Login/AgrementPage';
import BasicInfoPage from '../pages/Login/BasicInfoPage';
import ForgotPasswordPage from '../pages/Login/ForgotPasswordPage';
import LoginMainPage from '../pages/Login/LoginMainPage';
import ResetPasswordPage from '../pages/Login/ResetPasswordPage';
import SignUpPage from '../pages/Login/SignUpPage';
import BasicInfoForDBLifePage from '../pages/DBInsurance/BasicInfoForDBLifePage';
import SleepingJellyLoginPage from '../pages/Login/SleepingJellyLoginPage';
import LoginImages from '../assets/images/social-login/social-login-images';

export default function te() {
  // 로그인 페이지의 백그라운드 이미지를 렌더링시마다 랜덤으로 출력한다.
  const handleRandomLoginImage = () => {
    const randomIndex = Math.floor(Math.random() * LoginImages.length);
    return LoginImages[randomIndex];
  }
  return (
    <div
      className="w-screen h-screen overflow-y-auto no-scrollbar"
      style={{
        backgroundImage: `url(${handleRandomLoginImage()})`,
        backgroundSize: 'cover',
        backgroundPosition: 'left top',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Routes>
        <Route path="/" element={<LoginMainPage />} />
        <Route path="signWithEmail" element={<SignUpPage />} />
        <Route path="forgotPassword" element={<ForgotPasswordPage />} />
        <Route path="agrement" element={<AgrementPage />} />
        <Route path="basicInfo" element={<BasicInfoPage />} />
        <Route path="basicInfo-db" element={<BasicInfoForDBLifePage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path='login/jelly' element={<SleepingJellyLoginPage/>}/>
      </Routes>
    </div>
  );
}
